import AumentoCupo from "./AumentoCupoForms";
import React from 'react';
import {useJumboApp} from "@jumbo/hooks";
import {LAYOUT_NAMES} from "../../../layouts/layouts";


const FlujoAumentoCupo = () => {
  const {setActiveLayout} = useJumboApp();

  React.useEffect(() => {
      setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
      <div>
            <AumentoCupo/>
      </div>
  );
};

export default FlujoAumentoCupo;